import type { ReactNode } from "react";
import styles from "./HomeHeader.module.scss";

export function HomeHeader(): ReactNode {
  return (
    <div className={styles.headingBlock}>
      <span className={styles.eyebrow}>Partner Incentive Modeler</span>
      <h1 className={styles.title}>Incentive modeler self-service portal</h1>
    </div>
  );
}
